import anaConsts from 'analytics/constants';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import { AGENT_HANDOFF_REFERRAL_KEY, getAgentHandoffEvent } from 'constants/AgentHandoff';

export default (function () {
    var asyncPageLoadBindings = function asyncPageLoadBindings(data) {
        // ACS-3078 AC2: Check for passkey 3rd skip tracking flag
        const anaNextPageData = Storage.local.getItem(LOCAL_STORAGE.ANALYTICS_NEXT_PAGE_DATA) || {};
        let eventStrings = data.eventStrings || [];

        if (anaNextPageData.event284 !== undefined) {
            // Append event284=3 to the event strings
            const event284String = anaConsts.Event.EVENT_284 + '=' + anaNextPageData.event284;

            eventStrings = Array.isArray(eventStrings) ? [...eventStrings, event284String] : [event284String];

            // Clear the flag after use
            delete anaNextPageData.event284;

            if (Object.keys(anaNextPageData).length === 0) {
                Storage.local.removeItem(LOCAL_STORAGE.ANALYTICS_NEXT_PAGE_DATA);
            } else {
                Storage.local.setItem(LOCAL_STORAGE.ANALYTICS_NEXT_PAGE_DATA, anaNextPageData);
            }
        }

        let agentHandoffEvent;

        try {
            agentHandoffEvent = getAgentHandoffEvent(Storage.session.getItem(AGENT_HANDOFF_REFERRAL_KEY));
        } catch (e) {
            // No-op: if session storage is unavailable or throws, skip adding the agentic session event
        }

        if (agentHandoffEvent) {
            eventStrings = Array.isArray(eventStrings) ? [...eventStrings, agentHandoffEvent] : [agentHandoffEvent];
        }

        /* All of this data is specific to this event and should therefor be
         ** passed in an event item rather than stored in digitalData. */
        Sephora.analytics.utils.addNewItemFromSpec('event', {
            eventInfo: {
                eventName: anaConsts.ASYNC_PAGE_LOAD,
                attributes: {
                    eventStrings: eventStrings, // should pass event in array here
                    pageDetail: data.pageDetail,
                    pageName: data.pageName,
                    pageType: data.pageType,
                    previousPageName: data.previousPageName,
                    productStrings: data.productStrings,
                    navigationInfo: data.navigationInfo,
                    linkData: data.linkData, // prop55
                    world: data.world,
                    categoryFilters: data.categoryFilters,
                    storeId: data.storeId,
                    internalCampaign: data.internalCampaign,
                    creditCardStatus: data.creditCardStatus,
                    keywordPurchased: data.keywordPurchased, //eVar27
                    overlayTiers: data.overlayTiers, //s.prop61
                    eVar54: data.eVar54, // LOYLS-1226
                    eVar129: data.eVar129,
                    eVar38: data.eVar38,
                    prop48: data.prop48,
                    actionInfo: data.actionInfo,
                    eVar130: data.eVar130,
                    eVar140: data.eVar140,
                    eddDate: data.eddDate, // eVar141 - GUAR-8124
                    productReviews: data.productReviews, //prop32
                    prop28: data.prop28, // prop28
                    prop43: data.prop43 // prop43
                }
            }
        });
    };

    return asyncPageLoadBindings;
}());
